/**
 * Acción principal de cada etapa del presupuesto/ODT: el siguiente paso natural, a un clic.
 *
 * Fuente única de las etiquetas de acción. La leen la tabla de presupuestos
 * (`components/admin/Budget/buildRowActions`) y la cola del ciclo (`cicloMeta.nextActionFor`);
 * `stageMeta` solo describe la etapa (descripción y color), no sus acciones.
 *
 * Cada entrada es `{ key, label, tone }` o `null` si la etapa no tiene acción principal.
 * `key` es el handler que ejecuta la fila: approve | openOdtForm | openOdtStatus | downloadOdt.
 * Debe tener una entrada por cada etapa de `stageMeta` (lo verifica el test).
 */
const action = (key, label, tone) => ({ key, label, tone });

export const PRIMARY_ACTIONS = {
  esperando_aprobar: action('approve', 'Aprobar', 'success'),
  en_espera: null,
  rechazado: null,
  aprobado_sin_odt: action('approve', 'Crear ODT', 'success'),
  odt_no_asignada: action('openOdtForm', 'Editar ODT', 'primary'),
  odt_asignada: action('openOdtStatus', 'Ver estado', 'primary'),
  odt_en_proceso: action('openOdtStatus', 'Ver estado', 'primary'),
  finalizada: action('downloadOdt', 'Descargar ODT', 'success'),
};

/**
 * @param {string} stage etapa compuesta del presupuesto (`record.stage`)
 * @returns {{key:string,label:string,tone:string}|null}
 */
export function primaryActionFor(stage) {
  return PRIMARY_ACTIONS[stage] ?? null;
}
